import { render, staticRenderFns } from "./AcquistoSospeso.vue?vue&type=template&id=4f06eace"
import script from "./AcquistoSospeso.vue?vue&type=script&lang=js"
export * from "./AcquistoSospeso.vue?vue&type=script&lang=js"
import style0 from "./AcquistoSospeso.vue?vue&type=style&index=0&id=4f06eace&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports